import axios from 'axios'
import { Toast } from 'vant'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_PATH || '',
  timeout: 20000,
  responseType: 'text',
  transformResponse: [
    data => {
      return data
    }
  ]
})
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = localStorage.getItem('TOKEN') ? localStorage.getItem('TOKEN') : ''
    return config
  },
  error => {
    Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = JSON.parse(response.data) // Long型数值转化
    if (res.data && res.data.status_code && (res.data.status_code !== 200 && res.data.status_code !== 0)) {
      Toast.fail({
        message: res.msg || res.data.message,
        duration: 3 * 1000
      })
    }
    // 接口正常报错
    /*
    if (res.code !== 0 && res.code !== 200 && res.code !== 50002 && !response.config.headers['noErrToast']) {
      Toast.fail({
        message: res.msg || res.message,
        duration: 3 * 1000
      })
    }*/
    return res
  },
  error => {
    /*
    if (error && error.response) {
      const res = JSON.parse(error.response.data)
      if (res && res.code === 50002) {
        // 令牌不存在或已失效
        login(3)
      }
    } */
    return Promise.reject(error)
  }
)

export function post(url, params) {
  return service.post(url, params).then(
    res => {
      return res
    },
    err => {
      const errObj = JSON.parse(err.response.data)
      if (errObj.status !== 200) {
        Toast.fail({
          message: errObj.message,
          duration: 3 * 1000
        })
      }
      return Promise.reject(err)
    }
  )
}
export function put(url, params) {
  return service.put(url, params).then(
    res => {
      return res
    },
    err => {
      const errObj = JSON.parse(err.response.data)
      if (errObj.status !== 200) {
        Toast.fail({
          message: errObj.message,
          duration: 3 * 1000
        })
      }
      return Promise.reject(err)
    }
  )
}

export function get(url, params) {
  return service({
    method: 'get',
    url: url,
    params
  }).then(
    res => {
      return res
    },
    err => {
      return Promise.reject(err)
    }
  )
}

export function del(url, params) {
  return service({
    method: 'delete',
    url: url,
    params
  }).then(
    res => {
      return res
    },
    err => {
      return Promise.reject(err)
    }
  )
}

// 提供给上传使用
export function upload(url, params) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' }}
  return service.post(url, params, config).then(
    res => {
      return res
    },
    err => {
      return Promise.reject(err)
    }
  )
}

export default service
